import { render, staticRenderFns } from "./DomainRatings.vue?vue&type=template&id=b28c26e6&"
import script from "./DomainRatings.vue?vue&type=script&lang=js&"
export * from "./DomainRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports